
import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    title1: '以科技推動全球教育發展',
    title2: '',
    subTitle: '20 多年的值得信賴 | 以科技創新賦能教育',
    legacyEvolutionTitle: '我們的傳承，我們的發展',
    legacyEvolutionDesc1: '20 多年來，{brand} 一直是海外留學申請和服務業值得信賴的領導者。我們最初的使命是簡化全球教育之旅，如今我們已成為一家具有前瞻性思維的教育科技 (EdTech) 公司，致力於重新定義代理商、學校和學生的國際教育體驗。 ',
    legacyEvolutionDesc2: '憑藉數十年的行業經驗，我們識別並解決了全球教育領域的痛點，將傳統服務轉變為更快、更智能、更個性化的技術驅動解決方案。 ',
    ecosystemTitle: '我們的核心生態系',
    ecosystemDesc: '我們建立了一個多元化、整合性的教育平台，涵蓋海外學習之旅的每個階段，確保代理、學校和學生的學習過程零中斷、零延誤。 ',
    ecosystemType1: '代理',
    ecosystemTypeDesc1: 'B2B代理平台，代理微信小程序',
    ecosystemType2: '學校',
    ecosystemTypeDesc2: 'B2B2C品牌平台，教學輔助平台',
    ecosystemType3: '學生',
    ecosystemTypeDesc3: '學生平台、住宿、保險、學習中心',
    whyPartner1: '為何選擇與 ',
    whyPartner2: '{brand} 合作',
    whyPartner3: '?',
    reasonTitle1: '>20 多年的信賴',
    reasonDesc1: '我們了解全球教育產業的各個層面，並擁有為代理、學校和學生解決實際問題的良好記錄。 ',
    reasonTitle2: '技術驅動的效率',
    reasonDesc2: '人工智慧自動化、全天候支援和整合平台可為您節省時間、降低成本並最大限度地減少錯誤。 ',
    reasonTitle3: '端對端支援',
    reasonDesc3: '從申請到抵達（以及之後），我們涵蓋旅程的每一步——無需與多家供應商合作。 ',
    majorSysTitle1: '主要系统:',
    majorSysTitle2: '協助無縫運營',
    majorSysDesc: '我們的核心系統旨在簡化工作流程、減少人工工作量並確保營運平穩運行——無論您正在管理內部流程或支援客戶。 ',
    majorSys1: 'BMS - 內部 ERP 系統',
    majorSysFunc1: '端對端業務管理',
    majorSysFuncDesc1: '將銷售、申請、客戶資料和營運統一到一個直觀的平台。 ',
    majorSysFuncFeature11: '集中式客戶和應用程式追蹤',
    majorSysFuncFeature12: '自動化工作流程管理',
    majorSysFuncFeature13: '即時報告與分析',
    majorSysFuncFeature14: '無縫團隊協作',
    majorSys2: 'GEAR - B2B 代理門戶',
    majorSysDesc2: '專為提高代理工作效率而構建，使用 AI 驅動的工具來減少耗時的任務。 ',
    majorSysFuncFeature21: '即時業務概覽',
    majorSysFuncFeatureDesc21: '造訪儀表板，即時追蹤申請進度、佣金狀態和客戶更新。 ',
    majorSysFuncFeature22: '人工智慧驅動的應用程式自動化',
    majorSysFuncFeatureDesc22: '自動化文件檢查、表單填寫和審核工作流程，加快申請週轉速度。 ',
    majorSysFuncFeature23: '即時機構與課程查詢',
    majorSysFuncFeatureDesc23: '搜尋全球學校和課程的綜合資料庫，在幾分鐘內為學生匹配理想的選擇。 ',
    majorSysFuncFeature24: '線上佣金結算',
    majorSysFuncFeatureDesc24: '提交佣金請求、收集數位簽章並更快收到付款－不再需要文書工作或延遲。 ',
    majorSys31: '{brand} Assistance取得幫助 - ',
    majorSys32: '微信代理小程式',
    majorSysDesc3: '即使在旅途中也能保持聯繫並高效工作：',
    majorSysFuncFeature31: '隨時隨地取得資源：透過微信，隨時隨地取得海外學習指南、特定國家/地區的申請流程和準備清單。 ',
    majorSysFuncFeature32: 'AI 課程匹配：根據學生的成績、興趣和預算，透過行動裝置為他們推薦量身定制的課程。 ',
    majorSysFuncFeature33: '主要優勢：無論您身在何處，都不會錯過任何客戶機會或重要更新。 ',
    majorSys4: 'B2B2C 網站：學校和代理商的品牌解決方案',
    majorSysDesc4: '我們創建客製化的白標入口網站，讓您展示您的品牌，同時利用我們強大的技術來推動招生。 ',
    majorSysFuncFeature41: '學校品牌入口網站',
    majorSysFuncFeatureDesc41: '完全可自訂的平台，重點介紹海外學習項目，為學生和家長提供無縫體驗。強化品牌形象，簡化國際項目申請。 ',
    majorSysFuncFeature42: '代理品牌入口網站',
    majorSysFuncFeatureDesc42: '以您自己的品牌展示服務、合作機構和成功案例。從競爭對手中脫穎而出，建立信任，並簡化服務交付。',
    platformTitle: '專業平台：超越應用程式',
    platformDesc: '我們的解決方案透過創新的學習技術來支持學生的學業成功和機構的教學目標。 ',
    platformFeature1: '線上課程學校 (OSSD)',
    platformFeatureDesc1: '經認證的安大略省中學文憑課程，面向全球學生，時間安排靈活。幫助學生無需搬遷即可滿足國際學術要求。 ',
    platformFeature2: 'AI 教學輔助平台',
    platformFeatureDesc2: '全天候 AI 機器人提供即時教學輔助－解答問題、批改作業和強化概念。提升參與度，改善學習成果',
    miniAppTitle: '以學生為中心的小程式',
    miniAppDesc: '我們優先考慮學生在國外的舒適度和成功率，並透過小程式處理這些“瑣事”，讓他們能夠專注於學業。 ',
    miniAppApp1: '學習中心',
    miniAppAppDesc1: '一站式機場接送、學校註冊、銀行帳戶設定和緊急援助服務。可自訂的套餐可消除安頓壓力。 ',
    miniAppApp2: '遊學',
    miniAppAppDesc2: '短期課程讓學生在入學前體驗海外生活。減輕焦慮，增強信心，並幫助做出明智的決定。 ',
    miniAppApp3: '電子視訊證明',
    miniAppAppDesc3: '安全的影片證明，確認申請狀態、錄取通知書和入學情況。消除詐欺風險，讓您安心無憂。 ',
    learnMore: '了解更多',
    contactUs: '聯絡我們',
    companyName: '環球教育科技',
    companyName1:'國際教育聯盟',
    companyAddress: '香港科學園白石角第一期2W大樓5樓502室',
    companyAddress2:'廣東省廣州市天河區林和東路285號中匯人壽中心8樓',
    companyPhone: '852-2110-3835',
    companyPhone2:'+86 20 87564591',
  },
  route,
  message,
  ...layout,
};
